import {fetchBody, URL_RECUITMENTCONTRACTOR_ADD, URL_RECUITMENTCONTRACTOR_GET_LIST, URL_RECUITMENTCONTRACTOR_GET_DETAIL, URL_RECUITMENTCONTRACTOR_UPDATE} from "../config"
import { toLogout, cleanFetch } from "./apiTools";
import { getToken } from "../component/Login/Auth";

export function api_getRecruitmentContractorList ({mReqRecruitmentContractorList, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqRecruitmentContractorList, token}), 
      url: URL_RECUITMENTCONTRACTOR_GET_LIST, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_addRecruitmentContractor ({mReqRecruitmentContractorAdd, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqRecruitmentContractorAdd, token}), 
      url: URL_RECUITMENTCONTRACTOR_ADD, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_updateRecruitmentContractor ({mRespRecruitmentContractorDetail, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mRespRecruitmentContractorDetail, token}), 
      url: URL_RECUITMENTCONTRACTOR_UPDATE, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}


export function api_getRecruitmentContractorDetail ({mReqRecruitmentContractorStatusDetail, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqRecruitmentContractorStatusDetail, token}), 
      url: URL_RECUITMENTCONTRACTOR_GET_DETAIL, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}
